import { fetchRatingData } from '../../../regions/services/fetchRatingData';
import { TThunkAction } from '../../types/redux';
import { getRatingLoading } from './getRatingLoading';
import { getRatingSucceed } from './getRatingSucceed';
import { getRatingFailed } from './getRatingFailed';

export const getRating = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { filters } = getState();

    const { type, date, region } = filters;

    dispatch(getRatingLoading());

    const response = await fetchRatingData(context, { region: region.slug, date, type });

    if (response) {
      dispatch(getRatingSucceed(response));
    } else {
      dispatch(getRatingFailed());
    }
  };
};
